import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { act } from "react-dom/test-utils";
import { useDispatch } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";

import { PURGE } from "redux-persist";

import { authServies } from "../../services/authServices";
import { getDev } from "../Dev/devSlice";
import {
  toggleForgotPassword,
  toggleLogin,
  toggleSignUp,
  toogleTwoFactorChallengeModal,
} from "../modals/modalSlice";
import { openErrorSnack, openSnackBar } from "../modals/snackBarSlice";

const initialState = {
  loading: false,
  isLoggedIn: false,
  success: false,
  errorMsg: {},
  user: {},
  message: "",
};

// ? two factor challenge

export const twoFactorChallenge = createAsyncThunk(
  "auth/twoFactorChallenge",
  async (logs, { dispatch }) => {
    console.log(logs);
    try {
      // dispatch()
      await authServies.http.get("/sanctum/csrf-cookie");
      const response = await authServies.http.post(
        "/api/two-factor-challenge/",
        logs
      );
      dispatch(toogleTwoFactorChallengeModal());
      dispatch(toggleLogin());

      if (response.status === 204) {
        return response.status;
      }
    } catch (error) {
      if (error.response.status === 422) {
        dispatch(openErrorSnack({ message: error.response.data.message }));
        dispatch(toogleTwoFactorChallengeModal());
        return error.response;
      }
      return error.response;
    }
  }
);

// ?  Login User request
export const loginUser = createAsyncThunk(
  "auth/login",
  async (logs, { dispatch }) => {
    try {
      document.cookie =
        "XSRF-TOKEN=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      const csrf = await authServies.http.get("/sanctum/csrf-cookie");
      console.log("csrf", logs);

      const response = await authServies.http.post("/api/login", logs);
      console.log(response.data.two_factor);

      if (response.data.two_factor === true) {
        dispatch(toogleTwoFactorChallengeModal());
        console.log(response);
        return response.data.two_factor;
        // return response;
      } else if (response.data.two_factor === false) {
        // return response.data.two_factor;
        dispatch(getDev());
        console.log(response);
        dispatch(toggleLogin());

        return response;
        // thunkAPI.dispatch(toggleLogin());
      } else {
        return response;
      }
    } catch (error) {
      // return error.request.status;

      // if(error.response.)

      return error.response;
      // return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

// ? Register User Request
export const registerUser = createAsyncThunk(
  "auth/register",
  async (credentials, thunkAPI) => {
    try {
      const csrf = await authServies.http.get("/sanctum/csrf-cookie");

      // console.log(csrf);
      console.log(credentials);
      const response = await authServies.http.post("api/register", credentials);
      thunkAPI.dispatch(
        loginUser({
          email: credentials.email,
          password: credentials.password,
        })
      );
      thunkAPI.dispatch(toggleSignUp());
      thunkAPI.dispatch(
        openSnackBar({
          message:
            "we have sent you a verification Email, please confirm your Email",
        })
      );
      return response.data;
    } catch (error) {
      if (error.response.status === 500) {
        thunkAPI.dispatch(
          openErrorSnack({ message: error?.response?.data?.message })
        );
      }
      if (error.response.status === 422) {
        thunkAPI.dispatch(
          openErrorSnack({ message: error?.response?.data?.message })
        );
        return error.response;
      }
      return thunkAPI.rejectWithValue(error.response);

      // return error.response;
    }
  }
);

export const postVerifyDevEmail = createAsyncThunk(
  "auth/verifyDevEmail",
  async (param = null, { dispatch }) => {
    try {
      await authServies.http.get("/sanctum/csrf-cookie");
      const response = await authServies.http.post(
        `api/email/verification-notification`
      );
      dispatch(getDev());
      dispatch(openSnackBar({ message: response.data.data.message }));

      // return response.statusText;
    } catch (error) {
      if (error.response.status === 401) {
        dispatch(
          openErrorSnack({ message: "please sign in to perfom this action" })
        );
        dispatch(logoutUser());
      }
      if (error.response.status === 403) {
        dispatch(
          openErrorSnack({
            message: "you are not allowed to perform this request",
          })
        );
      }
      if (error.response.status === 422) {
        dispatch(openErrorSnack({ message: error.response.data.message }));
        return error.response.data;
      }
      if (error.response.status === 429) {
        dispatch(
          openErrorSnack({
            message: ` ${error.response.data.message} , try after some seconds`,
          })
        );
      }
      return error.response;
    }
  }
);

// ? confirm email verification
export const verifyDevEmail = createAsyncThunk(
  "auth/verifyDevEmail",
  async (param = null, { dispatch }) => {
    try {
      await authServies.http.get("/sanctum/csrf-cookie");
      const response = await authServies.http.get(`${param}`);
      dispatch(getDev());
      dispatch(
        openSnackBar({ message: "Your Account has been verified Successfully" })
      );

      dispatch(getDev());

      // return response.statusText;
      return response.data;
    } catch (error) {
      if (error.response.status === 401) {
        dispatch(
          openErrorSnack({ message: "please sign in to perfom this action" })
        );
        dispatch(logoutUser());
      }
      if (error.response.status === 403) {
        dispatch(
          openErrorSnack({
            message: "you are not allowed to perform this request",
          })
        );
      }
      if (error.response.status === 422) {
        dispatch(openErrorSnack({ message: error.response.data.message }));
        return error.response.data;
      }
      if (error.response.status === 429) {
        dispatch(
          openErrorSnack({
            message: ` ${error.response.data.message} , try after some seconds`,
          })
        );
      }
      return error.response;
    }
  }
);

// ? Logout User Request
export const logoutUser = createAsyncThunk("auth/logout", async () => {
  try {
    await authServies.http.get("/sanctum/csrf-cookie");
    const response = await authServies.http.post("api/logout");

    const dispatch = useDispatch();
    const navigate = useNavigate();

    <Navigate to="/" />;
    return response.data;
  } catch (error) {
    // return thunkAPI.rejectWithValue(error.response?.data);
    return error.response;
  }
});

// ? Forgot Password Request
export const forgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async (logs, { dispatch }) => {
    try {
      await authServies.http.get("/sanctum/csrf-cookie");
      const response = await authServies.http.post("api/forgot-password", logs);
      console.log(response);
      dispatch(
        openSnackBar({
          message: response.data.message,
        })
      );
      dispatch(toggleForgotPassword());
      return response.data;
    } catch (error) {
      if (error.response.status === 500) {
        dispatch(
          openErrorSnack({
            message: "you have to be online to perform this action",
          })
        );
      }
      if (error.response.status === 422) {
        dispatch(openErrorSnack({ message: error.response.data.message }));
        // return error.response.data;
      }
      return error.response;
    }
  }
);

// ? Reset Password Request
export const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async (logs, { dispatch }) => {
    try {
      await authServies.http.get("sanctum/csrf-cookie");
      const response = await authServies.http.post("api/reset-password", logs);
      dispatch(openSnackBar(dispatch({ message: response.data.message })));
      return response;
    } catch (error) {
      if (error.response.status === 401) {
        dispatch(
          openErrorSnack({ message: "please sign in to perfom this action" })
        );
      }
      if (error.response.status === 403) {
        dispatch(
          openErrorSnack({
            message: error.response.data.message,
          })
        );
      }
      if (error.response.status === 422) {
        dispatch(openErrorSnack({ message: error.response.data.message }));
        return error.response.data;
      }
      if (error.response.status === 429) {
        dispatch(
          openErrorSnack({
            message: ` ${error.response.data.message} , try after some seconds`,
          })
        );
        return error.response.data;
      }
      return error.response;
    }
  }
);

// ? Authentication Slice
export const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state, action) => {
        state.loading = true;
        state.error = action.payload;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        const error = action?.payload;
        console.log(error);
        if (error?.status === 422) {
          state.loading = false;
          state.isLoggedIn = false;
          state.errorMsg = error?.data?.errors;
        } else if (error?.status === 429) {
          state.loading = false;
          state.isLoggedIn = false;
          state.errorMsg = error?.data;
        } else if (error === true) {
          state.isLoggedIn = false;
          state.user = error?.data?.user;
        } else {
          state.isLoggedIn = true;
          state.errorMsg = {};
          state.loading = false;
          state.user = error?.data?.user;
        }
        // console.log(action.payload);
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.isLoggedIn = false;
        state.error = action.payload;
      })
      .addCase(registerUser.pending, (state, action) => {
        let response = action.payload;

        console.log(response);
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        const error = action.payload;
        console.log(error);
        if (error.status === 422) {
          state.loading = false;
          state.isLoggedIn = false;
          state.errorMsg = error.data.errors;
        }
        if (error.status === 403) {
          state.loading = false;
          state.isLoggedIn = false;
          state.errorMsg = error.data.errors;
        }
      })
      .addCase(registerUser.rejected, (state, action) => {
        const error = action.payload;
        console.log(error);
      })
      // .addCase(PURGE, (state) => {
      //   customEntityAdapter.removeAll(state);
      // });
      .addCase(logoutUser.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(logoutUser.fulfilled, (state, action) => {
        state.loading = false;
        state.isLoggedIn = false;
        state.success = false;
        console.log(action.payload);
        document.cookie =
          "XSRF-TOKEN=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie =
          "laravel_session=; expires=fri, 01 Jan 1970 00:00:00 UTC; path=/;";
      })
      .addCase(logoutUser.rejected, (state, action) => {
        console.log(action.payload);
      })
      .addCase(forgotPassword.pending, (state, action) => {
        console.log(action.payload);
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        console.log(action.payload);
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        console.log(action.payload);
      })
      .addCase(resetPassword.pending, (state, action) => {
        const status = action.payload;
        console.log(status);
        // const { status, data } = action.payload;
        // if (status === 422) {
        //   state.errorMsg = data?.message;
        //   state.success = false;
        // } else if (status === 404) {
        //   state.success = false;
        //   state.errorMsg = "404";
        //   state.pending = true;
        // }
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        const { status, data } = action.payload;
        // const status = action.payload;
        console.log(status);
        // const msg = action.payload.data.errors;
        if (status === 422) {
          console.log(action.payload);
          state.errorMsg = data?.errors;
          state.success = false;
          state.loading = false;
        } else if (status === 404) {
          state.message = "404";
        } else {
          state.success = true;
          state.loading = false;
          state.errorMsg = {};
          state.pending = false;
        }
      })
      .addCase(resetPassword.rejected, (state, action) => {
        console.log(action.payload);
        // const { status, data } = action.payload;
        // if (status === 422) {
        //   state.errorMsg = data?.message;
        //   state.success = false;
        // } else if (status === 404) {
        //   state.success = false;
        //   state.errorMsg = "404";
        //   state.pending = true;
        // }
      })
      .addCase(twoFactorChallenge.pending, (state, action) => {
        const data = action.payload;
        console.log(data);
      })
      .addCase(twoFactorChallenge.fulfilled, (state, action) => {
        const data = action.payload;
        if (data === 204) {
          state.isLoggedIn = true;
          state.success = true;
        }
        console.log(data);
      })
      .addCase(twoFactorChallenge.rejected, (state, action) => {
        const data = action.payload;
        console.log(data);
      })
      .addCase(verifyDevEmail.pending, (state, action) => {
        const data = action.payload;
        console.log(data);
      })
      .addCase(verifyDevEmail.fulfilled, (state, action) => {
        const data = action.payload;
        console.log(data);
      })
      .addCase(verifyDevEmail.rejected, (state, action) => {
        const data = action.payload;
        console.log(data);
      });
  },
});
export default authSlice.reducer;
